export default __webpack_public_path__ + "static/media/LP-D1-EV.b001e845.jpg";